class Collection extends require("lib/static-shim").default(
  window.Backbone.Collection
) {
  initialize(models, options) {
    if (models == null) {
      models = []
    }
    if (options == null) {
      options = {}
    }
    this.options = options
  }

  urlRoot(url) {
    return Pathwright.getAPIUrl(url)
  }
}

export default Collection
